// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface RESTRestoreToDifferentLocation
 */
export interface RESTRestoreToDifferentLocation {
    /**
     * Defines whether all versions of mailbox items will be restored.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    changedItems?: boolean | null;
    /**
     * Defines whether the deleted mailbox items will be restored.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    deletedItems?: boolean | null;
    /**
     * Defines whether the restored mailbox data will be marked as unread.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    markRestoredAsUnread?: boolean | null;
    /**
     * Defines whether the *Drafts* mailbox folder will not be restored.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    excludeDrafts?: boolean | null;
    /**
     * Defines whether the *Deleted Items* mailbox folder will not be restored.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    excludeDeletedItems?: boolean | null;
    /**
     * Defines whether the preserved items placed on In-Place Hold will not be restored.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    excludeInPlaceHoldItems?: boolean | null;
    /**
     * Defines whether the preserved items placed on Litigation Hold will not be restored.
     * @type {boolean}
     * @memberof RESTRestoreToDifferentLocation
     */
    excludeLitigationHoldItems?: boolean | null;
    /**
     * Specifies the email address of the mailbox to which you want to restore data.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    mailbox?: string;
    /**
     * Specifies the Microsoft Exchange server with Client Access Server (CAS) role. Data will be restored to a specified mailbox server.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    casServer?: string;
    /**
     * Specifies the mailbox folder to which you want to restore data.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    folder?: string;
    /**
     * Specifies the region of the target Exchange organization.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    officeRegion?: RESTRestoreToDifferentLocationOfficeRegionEnum;
    /**
     * Specifies the name of the target Exchange organization.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    officeOrganizationName?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the Exchange organization.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    userPassword?: string;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    userCode?: string;
    /**
     * Specifies the ID of the Microsoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    applicationCertificate?: string;
    /**
     * Specifies a user name of the account that will be used as a Microsoft Exchange account to restore data.  **Note**: This property is required if you want to use an application certificate for data restore. Use this property only with the `applicationCertificate` property. 
     * @type {string}
     * @memberof RESTRestoreToDifferentLocation
     */
    impersonationAccountName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreToDifferentLocationOfficeRegionEnum {
    Worldwide = 'Worldwide',
    Germany = 'Germany',
    China = 'China',
    UsDefence = 'USDefence',
    UsGovernment = 'USGovernment'
}

